<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>
    <!-- 头部输入/选择框 -->
    <form action="" class="form_content">
      <div class="form_item">
        <span>出发日期：</span>
        <div class="form_input" @click.stop="$refs.calendar.show = true">
          {{ form.orderDate }}
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>出发城市：</label>
          <div class="form_input text-row1" @click.stop="onCitySelectShow">
            {{ form.cityNameList.toString() }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>订单状态：</label>
          <div
            class="form_input text-row1"
            @click.stop="onCarPoolOrderStatusSeleteShow"
          >
            {{ form.carPoolOrderStatusNameList.toString() }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>支付状态：</label>
          <div
            class="form_input text-row1"
            @click.stop="onCarPoolPayStatusSeleteShow"
          >
            {{ form.carPoolPayStatusNameList.toString() }}
          </div>
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item">
          <label>姓名：</label>
          <input
            type="text"
            class="form_input"
            v-model="form.custName"
            placeholder="  输入乘客姓名"
          />
        </div>
        <div class="form_item">
          <label>订单：</label>
          <input
            type="text"
            v-model="form.orderNo"
            class="form_input"
            placeholder="  输入订单号"
          />
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item">
          <label>电话：</label>
          <input
            type="text"
            class="form_input"
            v-model="form.custTel"
            placeholder="  输入手机号码"
          />
        </div>
      </div>

      <button class="search_btn" type="button" @click="doQuery">查询</button>
    </form>
    <!-- 订单详情 -->
    <van-list
      class="m-1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      ref="list"
    >
      <!-- 订单面板 -->
      <div class="order_panel mt-1" v-for="(item, index) in list" :key="index">
        <div class="panel_index">{{ index + 1 }}</div>
        <div class="panel_item">
          <div class="panel_item_content">
            <p class="item_content_label">出发日期:</p>
            <div class="item_content_info info_title flex-1">
              {{ item.LeaveDateTime }}
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">线路:</p>
            <div class="item_content_info info_title flex-1">
              {{ item.LineName }}
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">订单号:</p>
            <p class="item_content_info flex-1">{{ item.OrderNo }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">乘客姓名:</p>
            <p class="item_content_info flex-1">{{ item.CustName }}</p>
            <p class="item_content_label phone_label_width">电话:</p>
            <p class="item_content_info flex-1">{{ item.CustTel }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">出发城市:</p>
            <p class="item_content_info flex-1">
              {{ item.StartCityDistrictName }}
            </p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">上车点:</p>
            <p class="item_content_info flex-1">{{ item.StartName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">下车点:</p>
            <p class="item_content_info flex-1">{{ item.EndName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">出行人数:</p>
            <p class="item_content_info flex-1">{{ item.TravelsMember }}</p>
            <p class="item_content_label">出行方式:</p>
            <p class="item_content_info flex-1">{{ item.TravelTypeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">价格:</p>
            <p class="item_content_info flex-1">{{ item.TotalPrice }}</p>
            <p class="item_content_label">下单方式:</p>
            <p class="item_content_info flex-1">{{ item.OrderTypeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">订单状态:</p>
            <p class="item_content_info flex-1">{{ item.OrderStatusName }}</p>
            <p class="item_content_label">支付状态:</p>
            <p class="item_content_info flex-1">{{ item.PayStatusName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">留言备注:</p>
            <p class="item_content_info flex-1">{{ item.Notes }}</p>
          </div>
        </div>
      </div>
    </van-list>
    <div class="fab">
      <van-button v-if="showBackToTop" @click="goToTop">回到顶部</van-button>
    </div>

    <!-- 日历组件 -->
    <Calendar
      ref="calendar"
      type="range"
      :allow-same-day="true"
      @confirm="onConfirm"
    ></Calendar>
    <!-- 出发城市弹窗 -->
    <van-popup
      v-model="cityShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="出发城市"
        show-toolbar
        :columns="cityList"
        @cancel="onCancelCity"
        @confirm="onSelectCity"
        value-key="Name"
      />
    </van-popup>
    <!-- 出发城市弹窗 多选 -->
    <!-- <van-popup
      v-model="cityShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="form.cityCodeList">
        <van-checkbox
          :name="item.Code"
          shape="square"
          v-for="(item, index) in cityList"
          :key="index"
          >{{ item.Name }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectCity"
        >确认</van-button
      >
    </van-popup> -->

    <!-- 订单状态弹窗 -->
    <van-popup
      v-model="carPoolOrderStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="订单状态"
        show-toolbar
        :columns="carPoolOrderStatusList"
        @cancel="onCancelOrderStatus"
        @confirm="onSelectOrderStatus"
        value-key="CodeName"
      />
    </van-popup>

    <!-- 订单状态弹窗 多选 -->
    <!-- <van-popup
      v-model="carPoolOrderStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="form.carPoolOrderStatusCodeList">
        <van-checkbox
          :name="item.CodeFlag"
          shape="square"
          v-for="(item, index) in carPoolOrderStatusList"
          :key="index"
          >{{ item.CodeName }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectOrderStatus"
        >确认</van-button
      >
    </van-popup> -->

    <!-- 订单状态弹窗 -->
    <van-popup
      v-model="carPoolPayStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-picker
        title="支付状态"
        show-toolbar
        :columns="carPoolPayStatusList"
        @cancel="onCancelPayStatus"
        @confirm="onSelectPayStatus"
        value-key="CodeName"
      />
    </van-popup>

    <!-- 支付状态弹窗 多选 -->
    <!-- <van-popup
      v-model="carPoolPayStatusShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-radio-group v-model="form.carPoolPayStatusCodeList">
        <van-radio
          ch
          :name="item.CodeFlag"
          shape="square"
          v-for="(item, index) in carPoolPayStatusList"
          :key="index"
          >{{ item.CodeName }}</van-radio
        >
      </van-radio-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectPayStatus"
        >确认</van-button
      >
    </van-popup> -->
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Calendar from "../../components/calendar.vue";
//import calendar from "@/js/date";
export default {
  components: {
    Header,
    Calendar,
  },

  data() {
    return {
      title: "拼车订单",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      form: {
        orderDate: this.$moment().format("YYYY-MM-DD"),
        cityNameList: [],
        cityCodeList: [],
        carPoolOrderStatusNameList: [],
        carPoolOrderStatusCodeList: [],
        carPoolPayStatusNameList: [],
        carPoolPayStatusCodeList: [],
        orderNo: "",
        custName: "",
        custTel: "",
      },
      start: 0,
      limit: 5,
      list: [],
      cityShow: false,
      carPoolOrderStatusShow: false,
      carPoolPayStatusShow: false,
      showBackToTop: false,
      cityList: [],
      carPoolOrderStatusList: [],
      carPoolPayStatusList: [],
    };
  },

  created() {
    //this.clickOrderSourcePopupShow();
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 200; // 当滚动超过200px时显示按钮
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动到顶部
    },

    // 出发城市选择函数
    async onCitySelectShow() {
      //debugger;
      if (this.cityList.length <= 0) {
        await this.$http
          .post(this.$api.getCity, {
            ProvinceCode: "440000",
          })
          .then((res) => {
            this.cityList = res.data; //res.data.map((item) => item.Name)
          });
      }
      this.cityShow = true;
    },

    // 订单状态选择函数
    async onCarPoolOrderStatusSeleteShow() {
      if (this.carPoolOrderStatusList.length <= 0) {
        await this.$http
          .post(this.$api.getCoreSysDictionaryCode, {
            CodeType: "CarPoolOrderStatus",
          })
          .then((res) => {
            this.carPoolOrderStatusList = res.data;
          });
      }
      this.carPoolOrderStatusShow = true;
    },

    // 支付状态选择函数
    async onCarPoolPayStatusSeleteShow() {
      if (this.carPoolPayStatusList.length <= 0) {
        await this.$http
          .post(this.$api.getCoreSysDictionaryCode, {
            CodeType: "CarPoolPayStatus",
          })
          .then((res) => {
            this.carPoolPayStatusList = res.data;
          });
      }
      this.carPoolPayStatusShow = true;
    },

    // 查询按钮函数
    doQuery() {
      console.log(this.form);

      this.list = [];
      this.start = 0;
      this.finished = false;
      this.$nextTick(() => this.$refs.list.check());
      //this.onLoad();
    },

    // 取消出发城市函数
    onCancelCity() {
      this.form.cityNameList = "";
      this.form.cityCodeList = "";
      this.cityShow = false;
    },

    // 确认出发城市函数
    onSelectCity(value) {
      this.form.cityNameList = value.Name;
      this.form.cityCodeList = value.Code;
      // debugger;
      // this.form.cityNameList = this.cityList
      //   .filter((v) => this.form.cityCodeList.some((g) => g == v.Code))
      //   .map((v) => v.Name);
      this.cityShow = false;
    },

    // 取消订单状态函数
    onCancelOrderStatus() {
      this.form.carPoolOrderStatusNameList = "";
      this.form.carPoolOrderStatusCodeList = "";
      this.carPoolOrderStatusShow = false;
    },

    // 确认订单状态函数
    onSelectOrderStatus(value) {
      this.form.carPoolOrderStatusNameList = value.CodeName;
      this.form.carPoolOrderStatusCodeList = value.CodeFlag;
      // this.form.carPoolOrderStatusNameList = this.carPoolOrderStatusList
      //   .filter((v) =>
      //     this.form.carPoolOrderStatusCodeList.some((g) => g == v.CodeFlag)
      //   )
      //   .map((v) => v.CodeName);
      this.carPoolOrderStatusShow = false;
    },

    // 取消支付状态函数
    onCancelPayStatus() {
      this.form.carPoolPayStatusNameList = "";
      this.form.carPoolPayStatusCodeList = "";
      this.carPoolPayStatusShow = false;
    },

    // 确认支付状态函数
    onSelectPayStatus(value) {
      this.form.carPoolPayStatusNameList = value.CodeName;
      this.form.carPoolPayStatusCodeList = value.CodeFlag;
      // this.form.carPoolPayStatusNameList = this.carPoolPayStatusList
      //   .filter((v) =>
      //     this.form.carPoolPayStatusCodeList.some((g) => g == v.CodeFlag)
      //   )
      //   .map((v) => v.CodeName);
      this.carPoolPayStatusShow = false;
    },

    // 日历确认函数
    onConfirm(e) {
      this.form.orderDate = this.$moment(e[0]).format("YYYY-MM-DD");
    },

    onLoad() {
      const params = {
        //_CompGID: null,
        OrderDate: this.$moment(this.form.orderDate).format(
          "YYYY-MM-DD 00:00:00"
        ),
        StartCity: this.form.cityCodeList.toString(),
        OrderStatus: this.form.carPoolOrderStatusCodeList.toString(),
        PayStatus: this.form.carPoolPayStatusCodeList.toString(),
        CustName: this.form.custName,
        OrderNo: this.form.orderNo,
        query: this.form.custTel,
        start: this.start,
        limit: this.limit,
      };
      this.$http.post(this.$api.getCarPoolUserDetail, params).then((res) => {
        if (res.success) {
          console.log(res.total);
          const total = res.total;
          res.data.forEach((item) => {
            item.LeaveDate = item.LeaveDate.split(" ")[0];
            item.LeaveTime =
              item.LeaveTime.split(":")[0] + ":" + item.LeaveTime.split(":")[1];
            item.LeaveDateTime =
              item.LeaveDateTime &&
              this.$moment(item.LeaveDateTime).format("YYYY-MM-DD HH:mm");
            this.list.push(item);
            //window.scrollTo(0, 0);
          });
          this.start += this.limit;
          this.loading = false;
          if (this.list.length >= total) {
            this.finished = true;
          }
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.fab {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 100; /* 确保按钮在页面其他内容之上 */
}
.form_content {
  padding-bottom: 15px;
  background-color: #fff;
  // 日期
  .form_item {
    display: flex;
    flex: 1;
    padding: 0.256rem;
    line-height: 0.75rem;
    box-sizing: border-box;
    & > input {
      width: 100%;
      border: none;
    }
    .date_split {
      margin: 0 0.256rem;
    }
    .form_input {
      border-bottom: 1px solid #000;
      min-width: 2.692rem;
      flex: 1;
      font-size: 0.359rem;
    }
    .van-button {
      flex: 1;
      margin-left: 0.128rem;
    }
  }
  .form_item_special {
    display: flex;
  }
  .search_btn {
    width: 40%;
    padding: 0.15rem;
    background-color: #33ccff;
    margin-top: 0.1rem;
    margin-left: 0.128rem;
    color: white;
    border-radius: 3px;
  }
  .form_item_column {
    .form_item {
      display: flex;
      .title {
        min-width: 2rem;
        text-align: left;
      }
      .van-checkbox {
        margin-bottom: 0.2rem;
      }
    }
    .button {
      padding: 0 0.3rem;
      text-align: right;
      & > :nth-child(1) {
        margin-right: 0.3rem;
        color: #33ccff;
      }
    }
  }
}
.order_panel {
  border-radius: 10px;
  padding: 0.15rem;
  background-color: #fff;
  text-align: left;
  position: relative;
  .panel_index {
    width: 0.5333rem;
    height: 0.5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    text-align: center;
    color: #fff;
    background-color: #f7a33c;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .panel_item {
    .panel_item_content {
      display: flex;
      line-height: 0.5rem;
      min-height: 1rem;
      .item_content_label {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d8d8d8;
        background-color: #f9f9f9;
      }
      .item_content_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #d8d8d8;
        padding: 0 5px;
        .info_btn {
          padding: 3px 3px;
          border-radius: 5px;
          color: #fff;
        }
        & > span {
          color: #000;
        }
      }
      .info_title {
        color: #fe6500;
      }
      .phone_label_width {
        width: 15%;
      }
    }
  }
}
.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }

  .van-button {
    font-size: 0.533rem;
  }
}
.order-source-popup {
  padding: 0.3rem;
  .order-source-popup-input {
    margin-bottom: 0.3rem;
  }
  .order-source-popup-clear {
    color: #33ccff;
    text-align: left;
    margin-bottom: 0.3rem;
  }
  .order-source-popup-radio {
    width: 100%;
    margin-bottom: 0.3rem;
    .popup-radio-item {
      margin-bottom: 0.2rem;
    }
  }
}
</style>
